import script from "./TabResumenTorneo.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabResumenTorneo.vue?vue&type=script&setup=true&lang=ts"

import "./TabResumenTorneo.vue?vue&type=style&index=0&id=cda7064c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cda7064c"]])

export default __exports__